import BAboutFirstBlockRussianBox from './BAboutFirstBlockRussianBox'

export default BAboutFirstBlockRussianBox
